import { Link } from 'react-router-dom';
import { getAssetUrl } from '../utils/assetUrl';

const Logo = ({
  isScrolled = false,
  isHomePage = false,
  defaultLogoSrc,
  invertedLogoSrc,
}) => {
  let logoImage;

  if (defaultLogoSrc && invertedLogoSrc) {
    if (isScrolled) {
      logoImage = invertedLogoSrc;
    } else {
      logoImage = isHomePage ? defaultLogoSrc : invertedLogoSrc;
    }
  } else {
    if (isScrolled) {
      logoImage = getAssetUrl('assets/images/scrolled-header.png');
    } else {
      logoImage = isHomePage
        ? getAssetUrl('assets/images/non-scrolled-header.png')
        : getAssetUrl('assets/images/logo_white.png');
    }
  }

  return (
    <Link to="/" className="logo">
      <img src={logoImage} alt="inLoop" />
    </Link>
  );
};

export default Logo;